import { render, staticRenderFns } from "./TZA.vue?vue&type=template&id=32c0245d&scoped=true&"
import script from "./TZA.vue?vue&type=script&lang=js&"
export * from "./TZA.vue?vue&type=script&lang=js&"
import style0 from "./TZA.vue?vue&type=style&index=0&id=32c0245d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c0245d",
  null
  
)

export default component.exports